import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function QuickCreditTopUp({ returnTo, onMessage }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleClick = () => {
    if (!user) return;
    if (user.plan !== 'ai') {
      onMessage?.('Please purchase the AI Practice plan first. You can review all available packages on the pricing page.');
    }
    navigate(`/pricing?return_to=${encodeURIComponent(returnTo)}`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        height: 34,
        borderRadius: 999,
        border: '1px solid rgba(79,70,229,.12)',
        background: 'rgba(79,70,229,.08)',
        color: '#4338CA',
        padding: '0 14px',
        fontWeight: 800,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,.55)',
        fontSize: 13,
      }}
    >
      <span style={{ fontSize: 14, lineHeight: 1 }}>+</span>
      Buy more credits
    </button>
  );
}
